<template>
    <template v-if="commandes.length">
        <div class="w-5/6 md:w-2/3 m-auto" id="commandes">
            <template v-for="commande in commandes">
                <!-- start  -->
                <div class="bg-gray-100 mx-auto border-gray-500 border rounded-sm text-gray-700 mb-0.5 h-30">
                    <div :class="{'border-yellow-600':(commande.etat === 'en attente'), 'border-green-600':(commande.etat === 'valide'), 'border-red-600':(commande.etat === 'annule')}" class="flex p-3 border-l-8">
                        <div class="space-y-1 border-r-2 pr-3">
                            <div class="text-sm leading-5 font-semibold"><span class="text-xs leading-4 font-normal text-gray-500">{{ __('ID') }} #</span>{{ commande.id }}</div>
                            <div class="text-sm leading-5 font-semibold"><span class="text-xs leading-4 font-normal text-gray-500 pr">{{ __('Montant') }}</span>
                                {{ commande.montant_total }} €</div>
                            <div class="text-sm leading-5 font-semibold">{{ (new Date(commande.created_at)).toLocaleString($page.props.metas.locale) }}</div>
                        </div>
                        <div class="flex-1 border-r-2">
                            <div class="ml-3 space-y-1 pr-3">
                                <div class="text-base leading-6 font-normal">{{ __(commande.client.civilite) }} {{ __(commande.client.prenom) }} {{ __(commande.client.nom) }}</div>
                                <div class="text-sm leading-4 font-normal">
                                    <span class="text-xs leading-4 font-normal text-gray-500">{{ __('Ref') }}. </span>
                                    <span v-if="commande.transaction_num">{{ commande.transaction_num }}</span>
                                    <span v-else>{{ __('neant') }}</span>
                                </div>
                                <div class="text-sm leading-4 font-normal">
                                    <span class="text-xs leading-4 font-normal text-gray-500">{{ __('Date_de_validation') }}. </span>
                                    <span v-if="commande.date_validation">{{ (new Date(commande.date_validation)).toLocaleString($page.props.metas.locale) }}</span>
                                    <span v-else>{{ __('neant') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="border-r-2 p-3">
                            <div >
                                <div class="m-2 border-gray-200 border-2 bg-gray-300 p-1">
                                    <div class="uppercase text-xs leading-4 font-medium">Carte</div>
                                    <div class="text-center text-sm leading-4 font-semibold text-gray-800">
                                        <span v-if="commande.type_carte">{{ commande.type_carte }}</span>
                                        <span v-else>{{ __('neant') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-3">
                            <div :class="{'bg-yellow-600':(commande.etat === 'en attente'), 'bg-green-600':(commande.etat === 'valide'), 'bg-red-600':(commande.etat === 'annule')}"
                                 class="m-2 p-1 w-20">
                                <div class="uppercase text-xs leading-4 font-semibold text-center text-white">
                                    {{ __(commande.etat) }}</div>
                            </div>
                        </div>
                        <div :class="{'invisible':(commande.etat !== 'valide')}" class="border-l-2 p-3">
                            <inertia-link as="button" :href="route('paiement.commande', {'id': commande.url_id})" class="p-2 text-gray-100 bg-cavilam-primary rounded-sm m-2 focus:outline-none">
                                <i class="fas fa-link"></i>
                            </inertia-link>
                        </div>
                    </div>
                </div>
                <!-- end -->
            </template>
        </div>
    </template>
    <template v-else>
        <div class="w-5/6 md:w-2/3 m-auto bg-white p-4 rounded-xs shadow-md">
            <p class="text-center font-bold">{{ __('aucune_commande_effectuee_par_le_passe') }}</p>
        </div>
    </template>
</template>

<script>
import App from "@/Layouts/App";

export default {
    layout: App,
    name: "Commandes",
    props: {
        commandes: Array,
    }
}
</script>

<style scoped>

</style>
